export interface MucTab {
  id: string;
  label: string;
  badge?: string | number;
}

export interface TabsProps {
  items: MucTab[];
  value: string;
  onChange: (id: string) => void;
  'aria-label'?: string;
}

/**
 * Tabs **gạch chân**: mục đang chọn có đường primary 2px dưới chân.
 *
 * Bản cũ là nhóm nút nền xám bo góc — trông giống `SegmentedControl` nên không
 * ai phân biệt được "đổi nội dung cả trang" với "lọc một bảng". Nay hai thứ
 * khác hẳn nhau về hình.
 */
export function Tabs({ items, value, onChange, 'aria-label': nhan = 'Nhóm tab' }: TabsProps) {
  return (
    <div role="tablist" aria-label={nhan} className="flex flex-wrap gap-1 border-b border-vien">
      {items.map((m) => {
        const dangChon = m.id === value;
        return (
          <button
            key={m.id}
            type="button"
            role="tab"
            aria-selected={dangChon}
            onClick={() => {
              onChange(m.id);
            }}
            className={`vung-bam -mb-px inline-flex items-center gap-2 border-b-2 px-3 text-co-ban transition-colors ${
              dangChon
                ? 'border-nhan font-semibold text-nhan'
                : 'border-transparent text-chu-phu hover:border-vien hover:text-chu'
            }`}
          >
            {m.label}
            {m.badge !== undefined && (
              <span className="so-lieu rounded-chip bg-neutral-nen px-1.5 py-0.5 text-phu text-chu-phu">
                {m.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
